var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 146,
    viewBox: "0 0 239 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15878",
    "data-name": "Group 15878",
    transform: "translate(14263 5461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15871",
    "data-name": "Group 15871",
    transform: "translate(-483 1264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5077",
    "data-name": "Rectangle 5077",
    width: 239,
    height: 146,
    rx: 9,
    transform: "translate(-13780 -6725)",
    fill: "#f3f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "image_1_",
    "data-name": "image (1)",
    transform: "translate(-14168 -5413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15873",
    "data-name": "Group 15873",
    transform: "translate(0 19.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15872",
    "data-name": "Group 15872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38213",
    "data-name": "Path 38213",
    d: "M37.28,207.285l-.029-.034a.94.94,0,0,0-1.4-.072L21.624,221.433a1.453,1.453,0,0,1-1.956.091l-5.99-4.974a.939.939,0,0,0-1.21.007l-.013.011L0,226.912v3.081a6.31,6.31,0,0,0,6.3,6.3h36.72a6.31,6.31,0,0,0,6.3-6.3v-8.774Z",
    transform: "translate(0 -206.903)",
    fill: "#b5b5b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15875",
    "data-name": "Group 15875",
    transform: "translate(11.428 8.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15874",
    "data-name": "Group 15874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38214",
    "data-name": "Path 38214",
    d: "M122.717,93.152a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,122.717,93.152Z",
    transform: "translate(-118.617 -93.152)",
    fill: "#b5b5b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15877",
    "data-name": "Group 15877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15876",
    "data-name": "Group 15876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38215",
    "data-name": "Path 38215",
    d: "M43.023,0H6.3A6.31,6.31,0,0,0,0,6.3V36.166l10.592-8.8a3.839,3.839,0,0,1,4.942-.024l4.97,4.127L33.8,18.156a3.846,3.846,0,0,1,5.691.274l9.835,11.376V6.3A6.31,6.31,0,0,0,43.023,0Zm-27.5,20.079a7.005,7.005,0,1,1,7.005-7.005A7.013,7.013,0,0,1,15.528,20.079Z",
    fill: "#b5b5b5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/Default Image.8bc5681a.svg";
export { ForwardRef as ReactComponent };